import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, TrendingUp } from 'lucide-react';
interface Slide5Props {
  isDark?: boolean;
}
export function Slide5({
  isDark = false
}: Slide5Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95,
      y: 20
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-888">
      <div className="min-h-full flex flex-col justify-center items-center max-w-5xl mx-auto px-6 sm:px-12 py-20 sm:py-24 text-center" data-id="element-889">
        <motion.h1 variants={itemVariants} className={`text-3xl sm:text-5xl font-serif font-medium mb-12 sm:mb-16 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-890">
          Why This Matters Now
        </motion.h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-16 w-full mb-12 sm:mb-16" data-id="element-891">
          <motion.div variants={itemVariants} className="flex flex-col items-center" data-id="element-892">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-red-500/10 to-red-600/5 flex items-center justify-center mb-5 sm:mb-6 border border-red-500/30 shadow-sm" data-id="element-893">
              <TrendingUp className="w-8 h-8 sm:w-10 sm:h-10 text-red-500" data-id="element-894" />
            </div>
            <h3 className={`text-lg sm:text-2xl font-bold mb-3 sm:mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-895">
              Impact
            </h3>
            <p className={`leading-relaxed text-sm sm:text-base px-4 ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-896">
              Leadership burnout impacts retention, performance, and culture
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center" data-id="element-897">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-heliona-orange/10 to-heliona-orange/5 flex items-center justify-center mb-5 sm:mb-6 border border-heliona-orange/30 shadow-sm" data-id="element-898">
              <Clock className="w-8 h-8 sm:w-10 sm:h-10 text-heliona-orange" data-id="element-899" />
            </div>
            <h3 className={`text-lg sm:text-2xl font-bold mb-3 sm:mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-900">
              Timing
            </h3>
            <p className={`leading-relaxed text-sm sm:text-base px-4 ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-901">
              Early intervention is less costly than replacement
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center" data-id="element-902">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-heliona-mint/10 to-heliona-mint/5 flex items-center justify-center mb-5 sm:mb-6 border border-heliona-mint/30 shadow-sm" data-id="element-903">
              <ShieldCheck className={`w-8 h-8 sm:w-10 sm:h-10 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-904" />
            </div>
            <h3 className={`text-lg sm:text-2xl font-bold mb-3 sm:mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-905">
              Prevention
            </h3>
            <p className={`leading-relaxed text-sm sm:text-base px-4 ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-906">
              Heliona stops problems before they start
            </p>
          </motion.div>
        </div>

        <motion.div variants={itemVariants} className={`max-w-3xl pt-10 sm:pt-14 mb-16 sm:mb-0 px-4 border-t ${isDark ? 'border-white/10' : 'border-heliona-beige'}`} data-id="element-907">
          <p className={`text-xl sm:text-3xl font-medium leading-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-908">
            Sustainable leadership starts with investing in{' '}
            <span className={`font-semibold italic ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-909">
              leader wellness
            </span>
          </p>
        </motion.div>
      </div>
    </motion.div>;
}